import React, { useState } from "react";
import styles from "./ClientNotification.module.css";

const ClientNotification = ({ onConfirm }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleConfirm = () => {
    setIsVisible(false);
    if (onConfirm) onConfirm(); // Navighează la pagină după confirmare
  };

  if (!isVisible) return null;

  return (
    <div className={styles.notificationContainer}>
      <div className={styles.notification}>
        <p>
        Choose a subscription and sign up! You will receive a free trial period.
        We will contact you, and then we can discuss a potential collaboration. <br />
          <strong>Sign up and wait for us to reach out to you!</strong>
        </p>
        <button className={styles.confirmButton} onClick={handleConfirm}>
          OK
        </button>
      </div>
    </div>
  );
};

export default ClientNotification;
